import type { SVGProps } from 'react';

const SvgPadlockUnlocked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16 10h-6V7c0-1.1.9-2 2-2s2 .9 2 2c0 .55.45 1 1 1s1-.45 1-1c0-2.21-1.79-4-4-4S8 4.79 8 7v3c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3m1 8c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1h8c.55 0 1 .45 1 1z"
    />
  </svg>
);
export default SvgPadlockUnlocked;
